import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc, updateDoc, Timestamp } from 'firebase/firestore';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/Modal.css';

interface StatusEditModalProps {
  show: boolean;
  handleClose: () => void;
  invoice: any;
  onStatusUpdated: () => void;
}

const StatusEditModal: React.FC<StatusEditModalProps> = ({
  show,
  handleClose,
  invoice,
  onStatusUpdated
}) => {
  const [status, setStatus] = useState<string>('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && invoice) {
      setStatus(invoice.status || 'En attente de Paiement');
    }
  }, [show, invoice]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!status) {
      toast.error("Veuillez sélectionner un statut");
      return;
    }

    setLoading(true);
    
    try {
      // Déterminer la collection et le document à mettre à jour
      let docRef;
      let updatePath;
      
      if (invoice.companyId && invoice.companyId !== 'ZakariaELORCHE') {
        // Facture Foodinnov
        docRef = doc(db, "prospects", "foodinnovCompanies");
        updatePath = `${invoice.companyId}.invoices`;
      } else {
        // Facture RegExport
        docRef = doc(db, "prospects", "companies");
        updatePath = `${invoice.companyId}.invoices`;
      }

      // Récupérer les factures existantes
      const docSnap = await getDoc(docRef);
      if (!docSnap.exists()) {
        toast.error("Document non trouvé");
        return;
      }

      const data = docSnap.data();
      const companyData = data[invoice.companyId];
      
      if (!companyData || !companyData.invoices) {
        toast.error("Données de la société non trouvées");
        return;
      }

      // Mettre à jour le statut de la facture spécifique
      const updatedInvoices = companyData.invoices.map((inv: any) => {
        if (inv.uid === invoice.uid || 
            (inv.id === invoice.id && 
             inv.opportunityType === invoice.opportunityType &&
             inv.qte === invoice.qte &&
             inv.pu === invoice.pu &&
             inv.montantHT === invoice.montantHT &&
             inv.montantTTC === invoice.montantTTC)) {
          return {
            ...inv,
            status: status,
            updatedAt: Timestamp.now()
          };
        }
        return inv;
      });

      // Mettre à jour dans Firestore
      await updateDoc(docRef, {
        [updatePath]: updatedInvoices
      });

      toast.success("Statut de la facture mis à jour avec succès");
      onStatusUpdated();
      handleClose();
      
    } catch (error) {
      console.error("Erreur lors de la mise à jour du statut:", error);
      toast.error("Erreur lors de la mise à jour du statut");
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Modifier l'état de la facture</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Statut de facture :</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: '14px'
              }}
            >
              <option value="En attente de Paiement">En attente de Paiement</option>
              <option value="Réglée">Réglée</option>
            </select>
          </div>

          <div className="modal-actions" style={{
            display: 'flex',
            gap: '10px',
            justifyContent: 'flex-end',
            marginTop: '20px'
          }}>
            <button
              type="button"
              onClick={handleClose}
              style={{
                padding: '8px 16px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                backgroundColor: '#fff',
                cursor: 'pointer',
                color: '#333',
                fontSize: '14px',
                fontWeight: '500',
                minWidth: '80px'
              }}
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '8px 16px',
                border: 'none',
                borderRadius: '4px',
                backgroundColor: '#007bff',
                color: '#fff',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.6 : 1
              }}
            >
              {loading ? 'Mise à jour...' : 'Mettre à jour'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StatusEditModal;
